export default {
  legacyLoansData: []
}
